import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.keys.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import _asyncToGenerator from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.keys.js";
import Vue from 'vue';
import $$ from '@/store/plugins/storage';
import { apisession, apienterprise, apilogout } from '@/api/index.js';
var namespace = 'globalStore';
$$.setNamespace(namespace);
var state = {
  RUN_ENV: '',
  user: $$.get('user') || {},
  // 用户信息
  enterprise: {},
  // 企业信息
  config: $$.get('config') || {},
  isInMain: $$.get('isInMain') || true,
  showHomebottomBar: true,
  pageReload: {},
  keepAliveList: ['Home', 'Order', 'Mine', 'FAQ', 'DOC'],
  androidBack: {},
  appointInfo: null,
  Authorization: $$.get('Authorization') || '',
  openid: $$.get('openid') || ''
};
var mutations = {
  _openid: function _openid(state, value) {
    state.openid = value;
  },
  _Authorization: function _Authorization(state, value) {
    state.Authorization = value;
  },
  _appointInfo: function _appointInfo(state, value) {
    state.appointInfo = value;
  },
  _RUN_ENV: function _RUN_ENV(state, value) {
    state.RUN_ENV = value;
  },
  _user: function _user(state, value) {
    state.user = value;
    localStorage.setItem('lang', value.locale || 'zh_CN');
    if (Vue.$i18n) {
      Vue.$i18n.locale = value.locale || 'zh_CN';
    }
  },
  _enterprise: function _enterprise(state, value) {
    state.enterprise = value;
  },
  _config: function _config(state, value) {
    for (var key in value) {
      // eslint-disable-next-line no-prototype-builtins
      if (value.hasOwnProperty(key)) {
        Vue.set(state.config, key, value[key]);
      }
    }
  },
  _isInMain: function _isInMain(state, value) {
    state.isInMain = value;
  },
  _showHomebottomBar: function _showHomebottomBar(state, value) {
    state.showHomebottomBar = value;
  },
  _pageReload: function _pageReload(state, value) {
    for (var key in value) {
      if (value.hasOwnProperty(key)) {
        Vue.set(state.pageReload, key, value[key]);
      }
    }
  },
  _keepAliveList: function _keepAliveList(state, value) {
    if (state.keepAliveList.indexOf(value) === -1) {
      state.keepAliveList.push(value);
    } else {
      state.keepAliveList = state.keepAliveList.filter(function (item) {
        return item !== value;
      });
    }
  },
  _androidBack: function _androidBack(state, value) {
    state.androidBack = value;
  }
};
var actions = {
  _ApiSession: function _ApiSession(_ref) {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var commit, state, res;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              commit = _ref.commit, state = _ref.state;
              _context.next = 3;
              return apisession();
            case 3:
              res = _context.sent;
              // 用户信息
              if (res.success) {
                commit('_user', res.data);
              } else {
                Vue.$vux.toast.text(res.message || '');
              }
            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  _ApiEnterprise: function _ApiEnterprise(_ref2) {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var commit, state, _yield$apienterprise, data, success, message;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              commit = _ref2.commit, state = _ref2.state;
              if (!(Object.keys(state.enterprise).length !== 0)) {
                _context2.next = 3;
                break;
              }
              return _context2.abrupt("return");
            case 3:
              _context2.next = 5;
              return apienterprise();
            case 5:
              _yield$apienterprise = _context2.sent;
              data = _yield$apienterprise.data;
              success = _yield$apienterprise.success;
              message = _yield$apienterprise.message;
              // 企业信息 v1.96 替换接口
              if (success) {
                // document.title = data.name
                commit('_enterprise', data);
              } else {
                Vue.$vux.toast.text(message || '');
              }
            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  _ApiLogout: function _ApiLogout(_ref3) {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var dispatch, state, _yield$apilogout, success, message;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              dispatch = _ref3.dispatch, state = _ref3.state;
              _context3.next = 3;
              return apilogout();
            case 3:
              _yield$apilogout = _context3.sent;
              success = _yield$apilogout.success;
              message = _yield$apilogout.message;
              // 登出
              if (success) dispatch('_ApiSession'); // 获取用户信息
              if (!success) Vue.$vux.toast.text(message || '');
            case 8:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }))();
  }
};
var getters = {};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  getters: getters,
  actions: actions
};